// @flow
import Merchant from './Merchant';

export type TVerifiableAccountInstitution = {
  name: string,
  institution_id: string,
};

export type TVerifiableAccountOptions = {
  id: string,
  name: string,
  institution: TVerifiableAccountInstitution,
  mask: string,
  type: string,
  subtype: string,
};

export default class VerifiableAccount {
  id: string;
  name: string;
  institution: TVerifiableAccountInstitution;
  mask: string;
  type: string;
  subtype: string;
  public_account_token: ?string

  constructor(options: TVerifiableAccountOptions) {
    this.id = options.id;
    this.name = options.name;
    this.institution = options.institution;
    this.mask = options.mask;
    this.type = options.type;
    this.subtype = options.subtype;
    this.public_account_token = null;
  }

  static init(options: TVerifiableAccountOptions): VerifiableAccount {
    return new VerifiableAccount(options);
  }

  get_corresponding_merchant(merchants: Array<Merchant>): ?Merchant {
    return merchants.find(merchant => merchant.provider_ids.plaid.includes(this.institution.institution_id)) || null;
  }

  to_json(): TVerifiableAccountOptions {
    return {
      id: this.id,
      name: this.name,
      institution: this.institution,
      mask: this.mask,
      type: this.type,
      subtype: this.subtype,
    };
  }

  set_public_account_token(token: string): VerifiableAccount {
    this.public_account_token = token;
    return this;
  }

  is_verified(): boolean {
    return this.public_account_token !== null;
  }
}
